import { useMemo } from 'react';

import type { GalleryData_Item } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { AnchorTarget, RelValue } from './../../ricos-types';
import { convertToGalleryItemList } from './../../_shared/media/convert-to-gallery-item-list';

export function useItems(
  items: GalleryData_Item[],
  relValue?: RelValue,
  anchorTarget?: AnchorTarget
) {
  const galleryItems = useMemo(() => {
    return convertToGalleryItemList(items, relValue, anchorTarget);
  }, [items]);

  return galleryItems;
}
